import { Box, Container } from "@mui/material"
import { DailyTask } from "./dailyTask/DailyTask"
import { AccessTools } from "./accessTools/AccessTools"
import { useContext } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import { UsageComponents } from "./UsageComponents"

export const UsageOverView = () => {

    const { tool_state, usage_state } = useContext(ToolContext);
    const { __SESSION, toolOwned } = tool_state
    const { graphDatasets, form } = usage_state

    const urlParams = new URLSearchParams(window.location.search);

    return (
        <Container sx={{pt:'32px !important'}}>
            <Box display="flex" flexDirection="column" gap="32px">
                <AccessTools platform="business"/> {/* if personal = 'personal' else if business = 'business' else if subtool = 'subtool' */}
                {urlParams.get('tabs') === 'usage-overview' ? 
                    <UsageComponents vldt="" __SESSION={__SESSION} toolOwned={toolOwned} graphDatasets={graphDatasets} interval={form.data.interval.value}/>
                :
                    <DailyTask toolOwnedList={toolOwned.data}/>
                }
                <Box minHeight="50px"></Box>
            </Box>
        </Container>
    )
}